import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { FORM_STYLES } from "../constants";
import { PageOneFormData } from "../models";

interface SystemGridItemProps {
  titleKey: string;
  name: keyof PageOneFormData["roomSystems"];
  withPaddingTop?: boolean;
}

const SystemGridItem = ({ titleKey, name, withPaddingTop }: SystemGridItemProps) => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageOneFormData>();

  return (
    <Grid
      md={6}
      xs={6}
      sx={{
        padding: "0px",
        paddingRight: "20px",
        paddingTop: withPaddingTop ? "20px" : "0px",
      }}
    >
      <Box
        sx={{
          border: FORM_STYLES.sectionBorder,
          borderRadius: FORM_STYLES.sectionBorderRadius,
          padding: FORM_STYLES.sectionPadding,
        }}
      >
        <Grid
          sx={{
            backgroundColor: FORM_STYLES.titleBackgroundColor,
            color: FORM_STYLES.titleColor,
            borderRadius: FORM_STYLES.titleBorderRadius,
          }}
        >
          <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
            {t(titleKey)}
          </ByzMuiTypography>
        </Grid>
        <Controller
          name={`roomSystems.${name}`}
          control={control}
          render={({ field }) => (
            <ByzMuiRadioButton
              {...field}
              typographyText="adult-patient-assessment.open,adult-patient-assessment.close"
              layout="row"
              border="none"
              fontSize={16}
            />
          )}
        />
      </Box>
    </Grid>
  );
};

export const RoomSystems = () => {
  return (
    <Grid md={5} xs={12} sx={{ padding: "0px" }}>
      <Stack direction={"row"}>
        <SystemGridItem
          titleKey="adult-patient-assessment.oxygen-system"
          name="oxygenSystem"
        />
        <SystemGridItem titleKey="adult-patient-assessment.windows" name="windows" />
      </Stack>
      <Stack direction={"row"}>
        <SystemGridItem
          titleKey="adult-patient-assessment.bed-brake"
          name="bedBrake"
          withPaddingTop
        />
        <SystemGridItem
          titleKey="adult-patient-assessment.companion-requirement"
          name="companionRequirement"
          withPaddingTop
        />
      </Stack>
    </Grid>
  );
};
